import { useForm } from "react-hook-form";
import DesignationRequestModel from "../../../models/company/designation/request/DesignationRequestModel";
import { OBJECT_NAME_RULE, OBJECT_DESCRIPTION_RULE } from "../../../utils/validation-utils";
import toasterUtils from "../../../utils/toaster-utils";
import { Button, FormControl, TextField } from "@mui/material";

interface DesignationProps {
    objDesignation: DesignationRequestModel;
    actionType: string;
    onCloseDesignation: () => void;
    onDesignationSave: (objDesignation: DesignationRequestModel) => void;
}

const DesignationCreateComponent = (props: DesignationProps) => {
    const {
        register,
        setValue,
        getValues,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<DesignationRequestModel>({
        mode: "onChange",
        defaultValues: props.objDesignation
    });

    const onSubmit = (formData: DesignationRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        props.onDesignationSave(formData);
    }

    return (
        <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.designationName}>
                        <TextField label="Designation Name" size="small" {...register("designationName", OBJECT_NAME_RULE)} error={!!errors.designationName}
                            helperText={errors.designationName?.message} autoComplete="off" required />
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.description}>
                        <TextField label="Description" multiline rows={3} size="small"
                            {...register("description", OBJECT_DESCRIPTION_RULE)} error={!!errors.description} helperText={errors.description?.message} autoComplete="off" />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 text-end m-t-sm">
                    <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                        Save
                    </Button>
                    <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseDesignation}>
                        Close
                    </Button>
                </div>
            </div>
        </form>
    );
};
export default DesignationCreateComponent;